<template>
  <div class="media-page">
    <!-- Hero Section with Background -->
    <section class="hero-section">
      <div class="hero-content">
        <h1 class="page-title">Become a Media Partner</h1>
      </div>
    </section>



    <!-- Media Partners Section -->
    <section class="past-partners-section">
      <div class="container-wide">
        <h2 class="section-title">Media Partners At The INTERNATIONAL EDU TRAVEL</h2>
        
        <!-- Strategic Media Partner -->
        <div class="partner-category">
          <h3 class="category-title">Strategic Media Partner</h3>
          <div class="partners-logos">
            <div class="logo-item">
              <a href="https://www.entrepreneur.com/en-ae" target="_blank" rel="nofollow noopener">
                <img src="https://www.globalaishow.com/wp-content/uploads/2024/03/entrepreneur-me.webp" alt="Entrepreneur Middle East" />
              </a>
            </div>
          </div>
        </div>

        <!-- Industry Media Partners -->
        <div class="partner-category">
          <h3 class="category-title">Industry Media Partners</h3>
          <div class="partners-logos">
            <div class="logo-item">
              <a href="https://www.timesofai.com/" target="_blank" rel="nofollow noopener">
                <img src="https://www.globalaishow.com/wp-content/uploads/2024/08/TIMES-OF-AI.webp" alt="TIMES OF AI" />
              </a>
            </div>
            <div class="logo-item">
              <a href="https://www.capitalbay.news/" target="_blank" rel="nofollow noopener">
                <img src="https://www.globalaishow.com/wp-content/uploads/2024/08/Capitalbaynews.svg" alt="Capital Bay News" />
              </a>
            </div>
            <div class="logo-item">
              <a href="https://ai2people.com/" target="_blank" rel="nofollow noopener">
                <img src="https://www.globalaishow.com/wp-content/uploads/2024/08/ai2people.webp" alt="AI2People" />
              </a>
            </div>
            <div class="logo-item">
              <a href="https://aithority.com/" target="_blank" rel="nofollow noopener">
                <img src="https://www.globalaishow.com/wp-content/uploads/2024/08/AiThority.webp" alt="AIThority" />
              </a>
            </div>
            <div class="logo-item">
              <a href="https://www.aitimejournal.com/" target="_blank" rel="nofollow noopener">
                <img src="https://www.globalaishow.com/wp-content/uploads/2024/08/AI-Time-Journal.webp" alt="AI Time Journal" />
              </a>
            </div>
            <div class="logo-item">
              <a href="https://bigdataanalyticsnews.com/" target="_blank" rel="nofollow noopener">
                <img src="https://www.globalaishow.com/wp-content/uploads/2024/08/Big-Data-Analytics.webp" alt="Big Data Analytics News" />
              </a>
            </div>
            <div class="logo-item">
              <a href="https://www.ainews.com/" target="_blank" rel="nofollow noopener">
                <img src="https://www.globalaishow.com/wp-content/uploads/2024/08/Ainews.webp" alt="AI News" />
              </a>
            </div>
            <div class="logo-item">
              <a href="https://theoutpost.ai/" target="_blank" rel="nofollow noopener">
                <img src="https://www.globalaishow.com/wp-content/uploads/2024/08/outpost.webp" alt="The Outpost" />
              </a>
            </div>
            <div class="logo-item">
              <a href="https://aitechtrend.com/" target="_blank" rel="nofollow noopener">
                <img src="https://www.globalaishow.com/wp-content/uploads/2024/08/Aitechtrend.webp" alt="AI Tech Trend" />
              </a>
            </div>
            <div class="logo-item">
              <a href="https://aimojo.io/" target="_blank" rel="nofollow noopener">
                <img src="https://www.globalaishow.com/wp-content/uploads/2024/08/AiMOJO.webp" alt="AI MOJO" />
              </a>
            </div>
            <div class="logo-item">
              <a href="https://dailyai.com/" target="_blank" rel="nofollow noopener">
                <img src="https://www.globalaishow.com/wp-content/uploads/2024/08/Daily-AI.webp" alt="Daily AI" />
              </a>
            </div>
            <div class="logo-item">
              <a href="https://aipressroom.com/" target="_blank" rel="nofollow noopener">
                <img src="https://www.globalaishow.com/wp-content/uploads/2024/08/AIpressroom.webp" alt="AI Press Room" />
              </a>
            </div>
            <div class="logo-item">
              <a href="https://gogetgpt.com/" target="_blank" rel="nofollow noopener">
                <img src="https://www.globalaishow.com/wp-content/uploads/2024/12/gogetgpt.webp" alt="GoGetGPT" />
              </a>
            </div>
            <div class="logo-item">
              <a href="https://www.coincarp.com/" target="_blank" rel="nofollow noopener">
                <img src="https://www.globalaishow.com/wp-content/uploads/2025/03/coincrap.webp" alt="CoinCarp" />
              </a>
            </div>
            <div class="logo-item">
              <a href="http://www.aiedgeinsights.com/" target="_blank" rel="nofollow noopener">
                <img src="https://www.globalaishow.com/wp-content/uploads/2025/11/AiEdgeInsights.svg" alt="AI Edge Insights" />
              </a>
            </div>
            <div class="logo-item">
              <a href="https://cryptosnewss.com/" target="_blank" rel="nofollow noopener">
                <img src="https://www.globalaishow.com/wp-content/uploads/2025/09/cryptosNewss.com-new-cover-logo.webp" alt="Cryptos Newss" />
              </a>
            </div>
          </div>
        </div>

        <!-- Magazine Partners -->
        <div class="partner-category">
          <h3 class="category-title">Magazine Partners</h3>
          <div class="partners-logos">
            <div class="logo-item">
              <a href="https://www.technologymag.net/" target="_blank" rel="nofollow noopener">
                <img src="https://www.globalaishow.com/wp-content/uploads/2024/11/Technologymag.webp" alt="Technology Magazine" />
              </a>
            </div>
            <div class="logo-item">
              <a href="https://canada.cioreview.com/" target="_blank" rel="nofollow noopener">
                <img src="https://www.globalaishow.com/wp-content/uploads/2024/10/cioreview.webp" alt="CIO Review" />
              </a>
            </div>
            <div class="logo-item">
              <a href="https://intlbm.com/" target="_blank" rel="nofollow noopener">
                <img src="https://www.globalaishow.com/wp-content/uploads/2024/09/International-Business-Magazine.webp" alt="International Business Magazine" />
              </a>
            </div>
            <div class="logo-item">
              <a href="https://www.securitymiddleeastmag.com/" target="_blank" rel="nofollow noopener">
                <img src="https://www.globalaishow.com/wp-content/uploads/2024/11/Securitymiddleeastmag.webp" alt="Security Middle East" />
              </a>
            </div>
            <div class="logo-item">
              <a href="https://www.fvmglobal.com/" target="_blank" rel="nofollow noopener">
                <img src="https://www.globalaishow.com/wp-content/uploads/2024/10/F-V-M.webp" alt="FVM" />
              </a>
            </div>
            <div class="logo-item">
              <a href="http://www.techpulsemea.com/" target="_blank" rel="nofollow noopener">
                <img src="https://www.globalaishow.com/wp-content/uploads/2025/11/Techpulse-logo.webp" alt="Tech Pulse" />
              </a>
            </div>
          </div>
        </div>

        <!-- Regional Media Partners -->
        <div class="partner-category">
          <h3 class="category-title">Regional Media Partners</h3>
          <div class="partners-logos">
            <div class="logo-item">
              <a href="https://www.gccbusinessnews.com/" target="_blank" rel="nofollow noopener">
                <img src="https://www.globalaishow.com/wp-content/uploads/2024/11/Gccbusinessnews.webp" alt="GCC Business News" />
              </a>
            </div>
            <div class="logo-item">
              <a href="https://emiratitimes.com/" target="_blank" rel="nofollow noopener">
                <img src="https://www.globalaishow.com/wp-content/uploads/2024/11/Emiratitimes.webp" alt="Emirati Times" />
              </a>
            </div>
            <div class="logo-item">
              <a href="https://nabd.com/" target="_blank" rel="nofollow noopener">
                <img src="https://www.globalaishow.com/wp-content/uploads/2024/11/Nabd.webp" alt="Nabd" />
              </a>
            </div>
            <div class="logo-item">
              <a href="https://www.edarabia.com/" target="_blank" rel="nofollow noopener">
                <img src="https://www.globalaishow.com/wp-content/uploads/2024/10/Ed-Arabia.webp" alt="EdArabia" />
              </a>
            </div>
            <div class="logo-item">
              <a href="https://fifreedomtoday.com/" target="_blank" rel="nofollow noopener">
                <img src="https://www.globalaishow.com/wp-content/uploads/2024/11/Fifreedomtoday.webp" alt="Fifreedom Today" />
              </a>
            </div>
            <div class="logo-item">
              <a href="https://mid-east.info/" target="_blank" rel="nofollow noopener">
                <img src="https://www.globalaishow.com/wp-content/uploads/2024/09/Middle-East-Information.webp" alt="Mid East Information" />
              </a>
            </div>
            <div class="logo-item">
              <a href="https://kanebridgenewsme.com/" target="_blank" rel="nofollow noopener">
                <img src="https://www.globalaishow.com/wp-content/uploads/2025/03/Kanebridge-News-ME.webp" alt="Kanebridge News ME" />
              </a>
            </div>
            <div class="logo-item">
              <a href="https://menews247.com/" target="_blank" rel="nofollow noopener">
                <img src="https://www.globalaishow.com/wp-content/uploads/2024/09/Middle-East-News-247.webp" alt="Middle East News 247" />
              </a>
            </div>
            <div class="logo-item">
              <a href="https://www.dubaiglobalnews.com/" target="_blank" rel="nofollow noopener">
                <img src="https://www.globalaishow.com/wp-content/uploads/2024/09/Dubai-Global-News.webp" alt="Dubai Global News" />
              </a>
            </div>
          </div>
        </div>

        <!-- Community Partners -->
        <div class="partner-category">
          <h3 class="category-title">Community Partners</h3>
          <div class="partners-logos">
            <div class="logo-item">
              <a href="https://allconfsbot.website/" target="_blank" rel="nofollow noopener">
                <img src="https://www.globalaishow.com/wp-content/uploads/2025/10/allconfsbot.webp" alt="All Confs Bot" />
              </a>
            </div>
          </div>
        </div>

        <!-- Distribution Partners -->
        <div class="partner-category">
          <h3 class="category-title">Distribution Partners</h3>
          <div class="partners-logos">
            <div class="logo-item">
              <a href="https://www.acnnewswire.com/" target="_blank" rel="nofollow noopener">
                <img src="https://www.globalaishow.com/wp-content/uploads/2024/10/Your-mind-media.webp" alt="Your Mind Media" />
              </a>
            </div>
            <div class="logo-item">
              <a href="https://www.acnnewswire.com/" target="_blank" rel="nofollow noopener">
                <img src="https://www.globalaishow.com/wp-content/uploads/2024/10/ACN-Newswire.webp" alt="ACN Newswire" />
              </a>
            </div>
            <div class="logo-item">
              <a href="https://zexprwire.com/" target="_blank" rel="nofollow noopener">
                <img src="https://www.globalaishow.com/wp-content/uploads/2024/10/ZEX.webp" alt="ZEX PR WIRE" />
              </a>
            </div>
            <div class="logo-item">
              <a href="https://go.stankeviciusmgm.com/" target="_blank" rel="nofollow noopener">
                <img src="https://www.globalaishow.com/wp-content/uploads/2024/11/Stankeviciusmgm.webp" alt="Stankeviciusmgm" />
              </a>
            </div>
            <div class="logo-item">
              <a href="https://keydifference.com/wire/" target="_blank" rel="nofollow noopener">
                <img src="https://www.globalaishow.com/wp-content/uploads/2024/11/KD-Wire.webp" alt="KD Wire" />
              </a>
            </div>
            <div class="logo-item">
              <a href="https://linktr.ee/yourprstrategist/" target="_blank" rel="nofollow noopener">
                <img src="https://www.globalaishow.com/wp-content/uploads/2024/09/PRstrategist.webp" alt="Your PR Strategist" />
              </a>
            </div>
            <div class="logo-item">
              <a href="https://julscorp.com/" target="_blank" rel="nofollow noopener">
                <img src="https://www.globalaishow.com/wp-content/uploads/2024/09/JULS-Corp.webp" alt="JULS Corporation" />
              </a>
            </div>
            <div class="logo-item">
              <a href="https://mediamark.digital/" target="_blank" rel="nofollow noopener">
                <img src="https://www.globalaishow.com/wp-content/uploads/2024/11/Mediamark.webp" alt="Mediamark" />
              </a>
            </div>
            <div class="logo-item">
              <a href="https://brandpr.io/" target="_blank" rel="nofollow noopener">
                <img src="https://www.globalaishow.com/wp-content/uploads/2024/11/BRANDPR-1.webp" alt="BRANDPR" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>

  </div>
</template>

<script>
export default {
  name: 'MediaPage',
  data() {
    return {
      formData: {
        firstName: '',
        lastName: '',
        jobTitle: '',
        companyName: '',
        country: '',
        email: '',
        countryCode: '+976',
        phone: '',
        contactMethod: '',
        partnershipType: [],
        platform: [],
        audienceReach: '',
        additionalInfo: '',
        newsletter: false,
        terms: false
      }
    }
  },
  methods: {
    submitForm() {
      console.log('Media partnership form submitted:', this.formData)
      // Add form submission logic here
      alert('Thank you for your interest in becoming a media partner! We will contact you shortly.')
    },
    scrollToForm() {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    }
  }
}
</script>

<style scoped>
/* Hero Section */
.hero-section {
  position: relative;
  padding: 200px 20px 180px;
  background: linear-gradient(135deg, #6B2DD8 0%, #8B5CF6 50%, #A78BFA 100%);
  overflow: hidden;
  min-height: 500px;
}

.hero-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: url('https://www.globalaishow.com/wp-content/uploads/2024/08/bg-1.svg');
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  opacity: 0.15;
  z-index: 0;
}

.hero-content {
  text-align: left;
  position: relative;
  z-index: 1;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 40px;
}

.page-title {
  font-size: 48px;
  font-weight: 700;
  color: #FFFFFF;
  margin: 0;
  line-height: 1.2;
  letter-spacing: -1px;
}

/* Form Section */
.form-section {
  padding: 60px 20px 100px;
  background: #ffffff;
}

.container {
  max-width: 750px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
}

.container-wide {
  max-width: 1200px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
}

.form-wrapper {
  max-width: 100%;
}

/* Form Card */


.media-form {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 15px;
}

.form-group {
  display: flex;
  flex-direction: column;
}

.form-group.full-width {
  grid-column: 1 / -1;
}

.form-label {
  font-size: 13px;
  font-weight: 500;
  color: #333;
  margin-bottom: 8px;
}

.form-input {
  padding: 13px 16px;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  font-size: 15px;
  font-family: inherit;
  background: #fafafa;
  width: 100%;
  box-sizing: border-box;
  transition: all 0.2s ease;
}

.form-input:hover {
  border-color: #d0d0d0;
  background: #ffffff;
}

.form-input:focus {
  outline: none;
  border-color: #6320EE;
  background: #ffffff;
  box-shadow: 0 0 0 3px rgba(99, 32, 238, 0.1);
}

.form-select {
  padding: 13px 16px;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  font-size: 15px;
  font-family: inherit;
  background: #fafafa;
  width: 100%;
  box-sizing: border-box;
  cursor: pointer;
  transition: all 0.2s ease;
}

.form-select:hover {
  border-color: #d0d0d0;
  background: #ffffff;
}

.form-select:focus {
  outline: none;
  border-color: #6320EE;
  background: #ffffff;
  box-shadow: 0 0 0 3px rgba(99, 32, 238, 0.1);
}

.form-textarea {
  padding: 13px 16px;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  font-size: 15px;
  font-family: inherit;
  background: #fafafa;
  width: 100%;
  box-sizing: border-box;
  transition: all 0.2s ease;
  resize: vertical;
}

.form-textarea:hover {
  border-color: #d0d0d0;
  background: #ffffff;
}

.form-textarea:focus {
  outline: none;
  border-color: #6320EE;
  background: #ffffff;
  box-shadow: 0 0 0 3px rgba(99, 32, 238, 0.1);
}

.phone-input-wrapper {
  display: flex;
  gap: 8px;
  width: 100%;
}

.country-select {
  padding: 13px 14px;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  font-size: 15px;
  background: #fafafa;
  cursor: pointer;
  min-width: 140px;
  font-weight: 400;
  transition: all 0.2s ease;
}

.country-select:hover {
  border-color: #d0d0d0;
  background: #ffffff;
}

.country-select:focus {
  outline: none;
  border-color: #6320EE;
  background: #ffffff;
  box-shadow: 0 0 0 3px rgba(99, 32, 238, 0.1);
}

.phone-input {
  flex: 1;
}

/* Checkbox Group */
.checkbox-group {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.checkbox-label {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  font-size: 14px;
  color: #333;
  cursor: pointer;
  line-height: 1.5;
}

.checkbox-label input[type="checkbox"] {
  margin-top: 2px;
  width: 18px;
  height: 18px;
  cursor: pointer;
  accent-color: #6320EE;
}

.checkbox-label.consent {
  font-size: 13px;
  color: #666;
  line-height: 1.6;
}

.link {
  color: #6320EE;
  text-decoration: underline;
}

/* Submit Button */
.submit-btn {
  width: 100%;
  padding: 16px;
  background: linear-gradient(135deg, #6320EE, #7c3aed);
  border: none;
  color: #FFFFFF;
  font-size: 15px;
  line-height: 1;
  font-family: sans-serif;
  border-radius: 8px;
  font-weight: 700;
  cursor: pointer;
  margin-top: 12px;
  transition: all 0.3s ease;
  box-shadow: 0 4px 14px rgba(99, 32, 238, 0.3);
}

.submit-btn:hover {
  background: linear-gradient(135deg, #7c3aed, #8b4fed);
  box-shadow: 0 6px 20px rgba(99, 32, 238, 0.4);
  transform: translateY(-1px);
}

/* Benefits Section */
.benefits-section {
  padding: 90px 20px;
  background: #ffffff;
}

.section-title {
  font-size: 40px;
  font-weight: 700;
  color: #1a1a1a;
  text-align: center;
  margin: 0 0 12px 0;
  letter-spacing: -0.5px;
}

.section-subtitle {
  font-size: 18px;
  color: #666;
  text-align: center;
  margin: 0 0 60px 0;
}

.benefits-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 30px;
}

.benefit-card {
  text-align: center;
  padding: 40px 25px;
  background: #f8f9ff;
  border-radius: 12px;
  transition: all 0.3s ease;
}

.benefit-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 12px 35px rgba(99, 32, 238, 0.15);
  background: #ffffff;
}

.benefit-icon {
  width: 80px;
  height: 80px;
  margin: 0 auto 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #6320EE, #7c3aed);
  border-radius: 50%;
  padding: 20px;
}

.benefit-icon img {
  width: 100%;
  height: 100%;
  filter: brightness(0) invert(1);
}

.benefit-title {
  font-size: 20px;
  font-weight: 700;
  color: #1a1a1a;
  margin: 0 0 12px 0;
}

.benefit-description {
  font-size: 14px;
  color: #666;
  line-height: 1.7;
  margin: 0;
}

/* Past Partners Section */
.past-partners-section {
  padding: 90px 20px;
  background: #f7f8fa;
}

.partner-category {
  margin-bottom: 70px;
}

.partner-category:last-child {
  margin-bottom: 0;
}

.category-title {
  font-size: 22px;
  font-weight: 600;
  color: #333;
  margin: 0 0 35px 0;
  text-align: left;
}

.partners-logos {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 30px;
  align-items: center;
}

.logo-item {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 25px;
  background: #ffffff;
  border-radius: 8px;
  transition: all 0.3s ease;
  min-height: 120px;
}

.logo-item:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
}

.logo-item a {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}

.logo-item img {
  max-width: 100%;
  max-height: 80px;
  height: auto;
  width: auto;
  transition: all 0.3s ease;
}

.logo-item:hover img {
  transform: scale(1.05);
}

/* CTA Section */
.cta-section {
  padding: 80px 20px;
  background: linear-gradient(135deg, #6320EE 0%, #7c3aed 100%);
}

.cta-content {
  text-align: center;
  max-width: 700px;
  margin: 0 auto;
}

.cta-title {
  font-size: 42px;
  font-weight: 700;
  color: #ffffff;
  margin: 0 0 16px 0;
  letter-spacing: -0.5px;
}

.cta-text {
  font-size: 18px;
  color: rgba(255, 255, 255, 0.9);
  margin: 0 0 35px 0;
  line-height: 1.6;
}

.cta-buttons {
  display: flex;
  gap: 16px;
  justify-content: center;
  flex-wrap: wrap;
}

.cta-btn {
  padding: 16px 40px;
  border-radius: 50px;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s ease;
  border: none;
  text-decoration: none;
  display: inline-block;
}

.cta-btn.primary {
  background: #ffffff;
  color: #6320EE;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.2);
}

.cta-btn.primary:hover {
  background: #f0f0f0;
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.25);
}

.cta-btn.secondary {
  background: transparent;
  color: #ffffff;
  border: 2px solid #ffffff;
}

.cta-btn.secondary:hover {
  background: rgba(255, 255, 255, 0.1);
  transform: translateY(-2px);
}

/* Responsive */
@media (max-width: 960px) {
  .form-row {
    grid-template-columns: 1fr;
  }

  .benefits-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 25px;
  }

  .partners-logos {
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
  }

  .category-title {
    font-size: 20px;
    margin-bottom: 25px;
  }

  .partner-category {
    margin-bottom: 50px;
  }

  .page-title {
    font-size: 36px;
  }

  .hero-content {
    padding: 0 20px;
  }

  .hero-section {
    padding: 140px 20px 120px;
    min-height: 400px;
  }

  .form-section {
    padding: 50px 20px 80px;
  }


}

@media (max-width: 600px) {
  .hero-section {
    padding: 100px 15px 90px;
    min-height: 320px;
  }

  .page-title {
    font-size: 28px;
  }

  .hero-content {
    padding: 0 15px;
  }

  .form-section {
    padding: 40px 15px 70px;
  }



  .benefits-grid {
    grid-template-columns: 1fr;
  }

  .partners-logos {
    grid-template-columns: repeat(2, 1fr);
    gap: 15px;
  }

  .category-title {
    font-size: 18px;
    margin-bottom: 20px;
  }

  .partner-category {
    margin-bottom: 40px;
  }

  .logo-item {
    padding: 20px;
    min-height: 100px;
  }

  .logo-item img {
    max-height: 60px;
  }

  .section-title {
    font-size: 32px;
  }

  .cta-title {
    font-size: 32px;
  }

  .cta-buttons {
    flex-direction: column;
  }

  .cta-btn {
    width: 100%;
  }
}
</style>
